import React, { useState, useEffect, useRef, useMemo, useDeferredValue } from "react";
import "./EmpGapForm.css";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { AUTH_API_BASE } from "./config/api";

//const API_BASE = window.location.origin.includes("localhost")
//  ? "http://localhost:5000/api/employeeRouter"
//  : "https://reports.agdxb.com/api/employeeRouter";

const API_BASE = `${AUTH_API_BASE}/employeeRouter`;
const ENTRIES_PAGE_SIZE = 100;
const POPUP_PAGE_SIZE = 100;

function EmpGapForm({ onLogout }) {
  const [empCode, setEmpCode] = useState("");
  const [gapDate, setGapDate] = useState("");
  const [entries, setEntries] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [empDisplay, setEmpDisplay] = useState("");
  const [isEmpPopupOpen, setIsEmpPopupOpen] = useState(false);
  const [empSearchText, setEmpSearchText] = useState("");
  const [employees, setEmployees] = useState([]);
  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterToDate, setFilterToDate] = useState("");
  const [tableSearch, setTableSearch] = useState("");
  const [empMap, setEmpMap] = useState({});
  const [originalGapDate, setOriginalGapDate] = useState(null);
  //const [absEmpCode, setAbsEmpCode] = useState("");
const [absEmpCode, setAbsEmpCode] = useState("");       // selected employee code
const [absEmpDisplay, setAbsEmpDisplay] = useState(""); // display name in input
const [fromDate, setFromDate] = useState(null);         // absence from date
const [toDate, setToDate] = useState(null);             // absence to date
const [startTime, setStartTime] = useState(null);       // absence start time
const [absenceCount, setAbsenceCount] = useState("");   // number of gaps
const [absenceGaps, setAbsenceGaps] = useState([]);   
const [gapCount, setGapCount] = useState(1);
  // generated gap dates
const [editingAbsId, setEditingAbsId] = useState(null); // for editing
const [originalFromDate, setOriginalFromDate] = useState(null);
const [originalToDate, setOriginalToDate] = useState(null);
const [absenceEntries, setAbsenceEntries] = useState([]);
const [activeEmpField, setActiveEmpField] = useState(""); 
const [numGaps, setNumGaps] = useState(""); 
const [loading, setLoading] = useState(false);
const [location, setLocation] = useState("");
const [locationList, setLocationList] = useState([]);
const [isLocationPopupOpen, setIsLocationPopupOpen] = useState(false);
const [locationSearch, setLocationSearch] = useState("");
const [isMultiSelect, setIsMultiSelect] = useState(false);
const [selectedEmps, setSelectedEmps] = useState([]); 
const [selectedEmpCodes, setSelectedEmpCodes] = useState([]); 
const [isPreviewPopupOpen, setIsPreviewPopupOpen] = useState(false);
const [previewData, setPreviewData] = useState([]);
const [gapEmpCodes, setGapEmpCodes] = useState([]);
const [absenceEmpCodes, setAbsenceEmpCodes] = useState([]);
const [isAbsencePreviewOpen, setIsAbsencePreviewOpen] = useState(false);
const [absenceReason, setAbsenceReason] = useState("");
const [absencePreviewData, setAbsencePreviewData] = useState([]);
const [gapSelectedEmps, setGapSelectedEmps] = useState([]);
const [absenceSelectedEmps, setAbsenceSelectedEmps] = useState([]);
const [gapFromDate, setGapFromDate] = useState(null);
const [gapToDate, setGapToDate] = useState(null);
const [entriesTotal, setEntriesTotal] = useState(0);
const [entriesPage, setEntriesPage] = useState(1);
const isMultiEmpSelected = selectedEmps.length > 1;
const gapDateRef = useRef(null);
const navigate = useNavigate();
const deferredEmpSearchText = useDeferredValue(empSearchText);
const deferredLocationSearch = useDeferredValue(locationSearch);
const deferredTableSearch = useDeferredValue(tableSearch);
const fetchLocations = async (searchText = "") => {
  try {
    const res = await axios.get(`${API_BASE}/Locations`, {
      params: {
        q: searchText || undefined,
        limit: POPUP_PAGE_SIZE,
      },
    });
    setLocationList(res.data || []);
    return res.data || [];
  } catch (err) {
    console.error("Fetch locations error", err);
    throw err;
  }
};

  const fetchEntries = async ({
    page = entriesPage,
    search = deferredTableSearch.trim(),
    fromDate = filterFromDate,
    toDate = filterToDate,
  } = {}) => {
    try {
      const res = await axios.get(`${API_BASE}/GapEntries`, {
        params: {
          page,
          pageSize: ENTRIES_PAGE_SIZE,
          search: search || undefined,
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
        },
      });

      const payload = res.data || {};
      const items = Array.isArray(payload) ? payload : payload.items || [];

      setEntries(items);
      setEntriesTotal(Array.isArray(payload) ? items.length : payload.total || 0);
      setEntriesPage(Array.isArray(payload) ? page : payload.page || page);
      setEmpMap((prev) => {
        const next = { ...prev };
        items.forEach((row) => {
          if (row.EMP_CODE && row.EMP_NAME) {
            next[row.EMP_CODE] = row.EMP_NAME;
          }
        });
        return next;
      });
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  const fetchEmployees = async (searchText = "") => {
    try {
      const res = await axios.get(`${API_BASE}/Employees`, {
        params: {
          q: searchText || undefined,
          limit: POPUP_PAGE_SIZE,
        },
      });
      const normalized = res.data.map((emp) => ({
        EMP_CODE: emp.EMPMST_CODE,
        EMP_NAME: emp.EMPMST_NAME,
      }));

      const map = {};
      normalized.forEach((e) => (map[e.EMP_CODE] = e.EMP_NAME));

      setEmpMap((prev) => ({ ...prev, ...map }));
      setEmployees(normalized);
      return normalized;
    } catch (err) {
      console.error("Fetch employees error:", err);
      throw err;
    }
  };

const handleSave = async () => {
  // ============================
  // VALIDATION FOR BULK INSERT
  // ============================
  if (!editingId && gapList.length > 0) {
    if (selectedEmps.length === 0 || gapList.some((g) => !g.gapDate)) {
      alert("Please select employees and fill all gap times");
      return;
    }
  }

  try {
    setLoading(true);

    // ============================
    // BULK SAVE (MULTI EMPLOYEE)
    // ============================
    if (!editingId && selectedEmps.length > 0 && gapList.length > 0) {
      // 1️⃣ Prepare employee codes
      const empCodes = selectedEmps.map((e) => e.EMP_CODE);

      // 2️⃣ Prepare gap dates
      const gapDates = gapList.map((g) =>
        g.gapDate.length === 16 ? `${g.gapDate}:00` : g.gapDate
      );

      // 3️⃣ Check if arrays are empty
      if (empCodes.length === 0 || gapDates.length === 0) {
        alert("Cannot save: select employees and fill gap dates");
        setLoading(false);
        return;
      }

      // 4️⃣ Send bulk insert POST request
      const res = await fetch(`${API_BASE}/GapEntries/bulk`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          EMP_CODES: empCodes,
          LOCATION: empCodes.length > 1 ? null : location,
          GAP_DATES: gapDates,
        }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text);
      }

      // ✅ Reset after successful insert
      setSelectedEmps([]);
      setGapEmpCodes([]);
      setEmpDisplay("");
      setLocation("");
      setGapList([{ gapDate: "" }]);
      setGapFromDate(null);
      setGapToDate(null);
      setNumGaps("");

      fetchEntries();
      setLoading(false);
      return;
    }

    /* ============================
       SINGLE SAVE / UPDATE
       ============================ */
    if (!empCode || !gapDate) {
      alert("Please fill both fields");
      setLoading(false);
      return;
    }

    const gapDateForDB = gapDate.length === 16 ? `${gapDate}:00` : gapDate;

    const url = editingId
      ? `${API_BASE}/GapEntries/${editingId}`
      : `${API_BASE}/GapEntries`;

    const body = editingId
      ? {
          oldEMP_CODE: editingId,
          oldGAP_DATE: originalGapDate,
          EMP_CODE: empCode,
          LOCATION: location,
          GAP_DATE: gapDateForDB,
        }
      : {
          EMP_CODE: empCode,
          GAP_DATE: gapDateForDB,
          LOCATION: location,
        };

    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text);
    }

    // ✅ RESET AFTER SINGLE SAVE/UPDATE
    setEmpCode("");
    setLocation("");
    setEmpDisplay("");
    setGapDate("");
    setGapList([{ gapDate: "" }]);
    setGapFromDate(null);
    setGapToDate(null);
    setNumGaps("");
    setEditingId(null);
    setOriginalGapDate(null);

    fetchEntries();
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error("Save error:", err.message);
    alert("Error saving entry: " + err.message);
  }
};

const handleSaveAbsence = async () => {
  try {
    // 1️⃣ Determine which employees to insert absence for
    const empCodesForAbsence =
      absenceEmpCodes.length > 0 ? absenceEmpCodes : selectedEmpCodes;

    if (empCodesForAbsence.length === 0) {
      alert("Please select employees for absence");
      return;
    }

    // 2️⃣ Validate date range and gap times
    if (!fromDate || !toDate || !startTime) {
      alert("Please fill all absence fields (dates & start time)");
      return;
    }

    // 3️⃣ Prepare gap dates array
   const gapDatesForDB = absencePreviewData
  .map((g) =>
    g.gapDate.length === 16 ? `${g.gapDate}:00` : g.gapDate
  )
  .filter(Boolean);// remove null or empty values

    if (gapDatesForDB.length === 0) {
      alert("Please fill all absence gap dates");
      return;
    }

    // 4️⃣ Call backend API
    const res = await fetch(`${API_BASE}/GapEntries/absence/bulk`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        EMP_CODES: empCodesForAbsence, // array of employees
        GAP_DATES: gapDatesForDB,      // array of gap dates
      }),
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text);
    }

    const data = await res.json();
    console.log("Absence inserted:", data);

    // 5️⃣ Reset form
    setAbsEmpCode("");
    setAbsEmpDisplay("");
    setFromDate(null);
    setToDate(null);
    setStartTime(null);
    setAbsenceCount("");
    setAbsenceGaps([]);
    setSelectedEmpCodes([]);

    fetchEntries(); // refresh table
    alert("Absence added successfully ✅");
  } catch (err) {
    console.error("Absence save error:", err);
    alert(`Error saving absence: ${err.message}`);
  }
};

const handleEdit = (row) => {
  setEmpCode(row.EMP_CODE);
  setEmpDisplay(`${row.EMP_CODE} — ${empMap[row.EMP_CODE] || ""}`);
  setLocation(row.LOCATION || "");
  setGapDate(row.GAP_DATE.slice(0, 16));
  setGapFromDate(null);
  setGapToDate(null);
  setEditingId(row.EMP_CODE);
  setOriginalGapDate(row.GAP_DATE);
};

// Frontend: include GAP_DATE in the request body
const handleDelete = async (row) => {
  if (!window.confirm("Are you sure?")) return;

  try {
    const empCode = encodeURIComponent(row.EMP_CODE);

    // send GAP_DATE in POST body
    const res = await fetch(`${API_BASE}/GapEntries/remove/${empCode}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ GAP_DATE: row.GAP_DATE }) // pass date
    });

    const data = await res.json();

    console.log("Delete result:", data);

    if (!data.success) {
      alert(`Record not found in DB (EMP_CODE: ${data.empCodeReceived})`);
      return;
    }

    fetchEntries();
    alert("Deleted successfully");
  } catch (err) {
    alert("Delete failed");
  }
};

const filteredEntries = entries;
const filteredEmployees = employees;
const filteredLocationList = locationList;

const selectedEmpCodeSet = useMemo(
  () => new Set(selectedEmps.map((emp) => emp.EMP_CODE)),
  [selectedEmps]
);

useEffect(() => {
  const timer = setTimeout(() => {
    fetchEntries({
      page: 1,
      search: deferredTableSearch.trim(),
      fromDate: filterFromDate,
      toDate: filterToDate,
    });
  }, 250);

  return () => clearTimeout(timer);
}, [deferredTableSearch, filterFromDate, filterToDate]);

useEffect(() => {
  if (!isEmpPopupOpen) return undefined;

  const timer = setTimeout(() => {
    fetchEmployees(deferredEmpSearchText.trim());
  }, 200);

  return () => clearTimeout(timer);
}, [deferredEmpSearchText, isEmpPopupOpen]);

useEffect(() => {
  if (!isLocationPopupOpen) return undefined;

  const timer = setTimeout(() => {
    fetchLocations(deferredLocationSearch.trim());
  }, 200);

  return () => clearTimeout(timer);
}, [deferredLocationSearch, isLocationPopupOpen]);


 const handleLogout = () => {
  localStorage.removeItem("token");
  if (onLogout) onLogout();
};

  const handleReset = () => {
  // GAP ENTRY RESET
  setEmpCode("");
  setEmpDisplay("");
  setGapDate("");
  setGapList([{ gapDate: "" }]);
  setGapFromDate(null);
  setGapToDate(null);
  setNumGaps("");
  setEditingId(null);
  setOriginalGapDate(null);

  // MULTI SELECT RESET
  setSelectedEmps([]);
  setSelectedEmpCodes([]);

  // LOCATION RESET
  setLocation("");

  // FILTER RESET
  setFilterFromDate("");
  setFilterToDate("");
  setTableSearch("");
  setEntriesPage(1);

  // ABSENCE RESET
  setAbsEmpCode("");
  setAbsEmpDisplay("");
  setFromDate(null);
  setToDate(null);
  setStartTime(null);
  setAbsenceCount("");
  setAbsenceGaps([]);
 
  // POPUP RESET
  setEmpSearchText("");
  setLocationSearch("");

  // PREVIEW POPUP RESET
  setIsPreviewPopupOpen(false);
  setPreviewData([]);

  fetchEntries({ page: 1, search: "", fromDate: "", toDate: "" });
};

const cellStyle = {
  padding: "8px 12px",
  borderBottom: "1px solid #dee2e6",
};

const editBtn = {
  background: "#198754",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  padding: "4px 10px",
  marginRight: 6,
  cursor: "pointer",
};

const deleteBtn = {
  background: "#dc3545",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  padding: "4px 10px",
  cursor: "pointer",
};
const inputStyle = {
  width: "100%",
  padding: "6px 8px",
  fontSize: "13px",
  borderRadius: "4px",
  border: "1px solid #ccc",
};

const [gapList, setGapList] = useState([
  { gapDate: "" }
]);

const formatGapDateTime = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  const h = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  return `${y}-${m}-${d}T${h}:${min}`;
};

const buildGapDateTimeFromTime = (baseDate, timeDate) => {
  const nextDate = new Date(baseDate);
  nextDate.setHours(timeDate.getHours(), timeDate.getMinutes(), 0, 0);
  return formatGapDateTime(nextDate);
};

const generateGapEntriesFromRange = ({ firstGapDateTime, count, fromDate, toDate }) => {
  if (!firstGapDateTime || count === "" || Number.isNaN(Number(count)) || Number(count) < 0) {
    return [{ gapDate: firstGapDateTime || "" }];
  }

  const baseDateTime = new Date(firstGapDateTime);
  if (Number.isNaN(baseDateTime.getTime())) {
    return [{ gapDate: firstGapDateTime }];
  }

  const rangeStart = fromDate ? new Date(fromDate) : new Date(baseDateTime);
  const rangeEnd = toDate ? new Date(toDate) : new Date(baseDateTime);

  rangeStart.setHours(0, 0, 0, 0);
  rangeEnd.setHours(0, 0, 0, 0);

  if (rangeStart > rangeEnd) return [{ gapDate: firstGapDateTime }];

  const nextGapList = [];
  const cursor = new Date(rangeStart);

  while (cursor <= rangeEnd) {
    for (let i = 0; i <= Number(count); i++) {
      const slot = new Date(cursor);
      slot.setHours(
        baseDateTime.getHours() + i * 2,
        baseDateTime.getMinutes(),
        0,
        0
      );
      nextGapList.push({ gapDate: formatGapDateTime(slot) });
    }
    cursor.setDate(cursor.getDate() + 1);
  }

  return nextGapList;
};

const openPreviewPopup = () => {
  if (selectedEmps.length === 0) {
    alert("Please select employees");
    return;
  }

  if (gapList.some((g) => !g.gapDate)) {
    alert("Please fill all gap date/time fields");
    return;
  }

  const data = [];

  for (const emp of selectedEmps) {
    for (const g of gapList) {
      data.push({
        empCode: emp.EMP_CODE,
        empName: emp.EMP_NAME, // ✅ ADD THIS
        location: selectedEmps.length > 1 ? "-" : location,
        gapDate: g.gapDate,
      });
    }
  }

  setPreviewData(data);

  setIsAbsencePreviewOpen(false);
  setIsPreviewPopupOpen(true);
};


const openAbsencePreviewPopup = () => {
  if (absenceEmpCodes.length === 0) {
    alert("Please select employees");
    return;
  }

  if (!fromDate || !toDate || !startTime || !absenceCount) {
    alert("Please fill From Date, To Date, Time and No.of gaps");
    return;
  }

  if (absenceGaps.length === 0) {
    alert("No absence gaps generated");
    return;
  }

  const preview = [];

  absenceSelectedEmps.forEach((emp) => {
    absenceGaps.forEach((g) => {
      preview.push({
        empCode: emp.EMP_CODE,
        empName: emp.EMP_NAME,
        gapDate: g.gapDate,
      });
    });
  });

  setAbsencePreviewData(preview);

  // ✅ IMPORTANT FIX
  setIsPreviewPopupOpen(false);
  setIsAbsencePreviewOpen(true);
};

useEffect(() => {
  if (gapEmpCodes.length > 1) {
    setLocation("");  // clear location automatically
  }
}, [gapEmpCodes]);

  return (
    <div
  className="emp-gap-root"
  style={{
    display: "flex",
    gap: 20,
    flexWrap: "nowrap",     // ✅ MUST
    alignItems: "stretch",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    boxSizing: "border-box",
  }}
>

{/* FORM CARD */}
      {/* LEFT FORM CARD */}
<div
  style={{
    flex: "0 0 380px",      
    maxWidth: 380,  
    background: "#fff",
    padding: 0,
    marginTop: 0,
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
  }}
>

       <div
  className="emp-gap-card"
  style={{
    flex: 1,
    minWidth: 300,
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  }}
>

        <h2 style={{ marginBottom: 10, color: "#198754" }}>Employee Gap Entry</h2>

        <div style={{ marginBottom: 10 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: 600 }}>EMP CODE</label>
          <input
            type="text"
            value={empDisplay}
            readOnly
            placeholder="Click to select employee"
            onClick={() => {
  setIsEmpPopupOpen(true);
  setActiveEmpField("gap");
  setIsMultiSelect(true);   // ✅ SINGLE
  setSelectedEmps([]);
  setEmpSearchText("");
}}

            style={{
              width: "100%",
              padding: 12,
              border: "1px solid #ccc",
              borderRadius: 8,
              cursor: "pointer",
              backgroundColor: "#f9f9f9",
              transition: "0.2s",
            }}
          />
        </div>

<div style={{ marginBottom: 20 }}>
  <label style={{ display: "block", marginBottom: 5, fontWeight: 600 }}>
    LOCATION (Vehicle)
  </label>
  <input
  type="text"
  value={location}
  readOnly
  placeholder={
  gapEmpCodes.length > 1
    ? "Location disabled for multiple employees"
    : "Click to select vehicle"
}
onClick={() => {
  if (gapEmpCodes.length > 1) return; 
  setIsLocationPopupOpen(true);
  setLocationSearch("");
}}
style={{
  width: "100%",
  padding: 12,
  border: "1px solid #ccc",
  borderRadius: 8,
  cursor: gapEmpCodes.length > 1 ? "not-allowed" : "pointer",
  backgroundColor: gapEmpCodes.length > 1 ? "#e9ecef" : "#f9f9f9",
  color: gapEmpCodes.length > 1 ? "#6c757d" : "#000",
}}

/>

</div>
        <div style={{ marginBottom: 15 }}>
{editingId ? (
  /* ===== EDIT MODE (single – unchanged) ===== */
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 8,
      marginBottom: 8,
    }}
  >
  <DatePicker
    selected={gapDate ? new Date(gapDate) : null}
    onChange={(date) => {
      if (!date) return;

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");

      setGapDate(`${year}-${month}-${day}T${hour}:${minute}`);
    }}
    showTimeSelect
    timeFormat="HH:mm"
    timeIntervals={1}
    dateFormat="yyyy-MM-dd HH:mm"
    placeholderText="YYYY-MM-DD HH:mm"
    popperPlacement="bottom-start"
    customInput={
      <input
        type="text"
        style={{
          width: "100%",
          height: 42,              // SAME as EMP CODE
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: 5,
          fontSize: 14,
          cursor: "text",
        }}
      />
    }
  />
</div>
) : (
  /* ===== ADD MODE (MULTI BOX WITH +) ===== */
  <>
  <div style={{ marginBottom: 10 }}>
    <label style={{ display: "block", marginBottom: 5, fontWeight: 600 }}>
      FROM DATE / TO DATE
    </label>
    <div style={{ display: "flex", gap: 8 }}>
      <DatePicker
        selected={gapFromDate}
        onChange={(date) => {
          setGapFromDate(date);

          const count = parseInt(numGaps, 10);
          if (gapList[0]?.gapDate && count >= 1) {
            setGapList(
              generateGapEntriesFromRange({
                firstGapDateTime: gapList[0].gapDate,
                count,
                fromDate: date,
                toDate: gapToDate,
              })
            );
          }
        }}
        dateFormat="yyyy-MM-dd"
        placeholderText="From Date"
        customInput={<input style={{ flex: 1, height: 36, padding: "6px 10px", border: "1px solid #ccc", borderRadius: 6, fontSize: 14 }} />}
      />
      <DatePicker
        selected={gapToDate}
        onChange={(date) => {
          setGapToDate(date);

          const count = parseInt(numGaps, 10);
          if (gapList[0]?.gapDate && count >= 1) {
            setGapList(
              generateGapEntriesFromRange({
                firstGapDateTime: gapList[0].gapDate,
                count,
                fromDate: gapFromDate,
                toDate: date,
              })
            );
          }
        }}
        minDate={gapFromDate || undefined}
        dateFormat="yyyy-MM-dd"
        placeholderText="To Date"
        customInput={<input style={{ flex: 1, height: 36, padding: "6px 10px", border: "1px solid #ccc", borderRadius: 6, fontSize: 14 }} />}
      />
    </div>
  </div>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 6,
      marginBottom: 8,
    }}
  >
    {/* DatePicker input */}
    <DatePicker
      selected={gapList[0]?.gapDate ? new Date(gapList[0].gapDate) : null}
      onChange={(date) => {
        if (!date) return;
        const baseDate =
          gapFromDate || gapToDate || (gapList[0]?.gapDate ? new Date(gapList[0].gapDate) : new Date());
        const formatted = buildGapDateTimeFromTime(baseDate, date);

        if (!gapFromDate) {
          const start = new Date(baseDate);
          start.setHours(0, 0, 0, 0);
          setGapFromDate(start);
        }

        if (!gapToDate) {
          const end = new Date(baseDate);
          end.setHours(0, 0, 0, 0);
          setGapToDate(end);
        }
        const count = parseInt(numGaps, 10);
        if (count >= 1) {
          setGapList(
            generateGapEntriesFromRange({
              firstGapDateTime: formatted,
              count,
              fromDate: gapFromDate || baseDate,
              toDate: gapToDate || baseDate,
            })
          );
          return;
        }

        setGapList([{ gapDate: formatted }]);
      }}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={1}
      timeCaption="Time"
      dateFormat="HH:mm"
      placeholderText="Enter gap time"
      customInput={
        <input
          style={{
            flex: 1,
            height: 36,
            padding: "6px 10px",
            border: "1px solid #ccc",
            borderRadius: 6,
            fontSize: 14,
          }}
        />
      }
    />

  {/* SMALL BOX: NUMBER OF GAPS */}
  <input
    type="number"
    min="1"
    placeholder="No.of gaps"
    value={numGaps}
    style={{ width: 110, height: 36, padding: "6px 10px", border: "1px solid #ccc", borderRadius: 6, fontSize: 14 }}
    onChange={(e) => {
      const value = e.target.value;
      setNumGaps(value);

      if (!gapList[0].gapDate) {
        alert("Please fill the first gap time before entering number of gaps.");
        setNumGaps("");
        return;
      }

      const count = parseInt(value, 10);
      if (isNaN(count) || count < 1) return;

      setGapList(
        generateGapEntriesFromRange({
          firstGapDateTime: gapList[0].gapDate,
          count,
          fromDate: gapFromDate,
          toDate: gapToDate,
        })
      );
    }}
  />
  </div>

  </>
)}
</div>
<div style={{ display: "flex", gap: 12 }}>
          <button
  onClick={() => {
  fetchEmployees();
    if (editingId) {
      // UPDATE MODE → Direct Save (no preview)
      handleSave();
    } else {
      // ADD MODE → Open Preview Popup
      openPreviewPopup();
    }
  }}
  style={{
    flex: 1,
    backgroundColor: editingId ? "#ffc107" : "#198754",
    color: "#fff",
    padding: 12,
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    transition: "0.2s",
  }}
  onMouseOver={(e) =>
    (e.currentTarget.style.backgroundColor = editingId
      ? "#e0a800"
      : "#157347")
  }
  onMouseOut={(e) =>
    (e.currentTarget.style.backgroundColor = editingId
      ? "#ffc107"
      : "#198754")
  }
>
  {editingId ? "UPDATE" : "ADD"}
</button>

          <button
            onClick={handleReset}
            style={{
              flex: 1,
              backgroundColor: "#6c757d",
              color: "#fff",
              padding: 12,
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#5a6268")}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#6c757d")}
          >
            RESET
          </button>
        </div>
</div>
        
<div
  className="emp-gap-card"
  style={{
    flex: 1,
    minWidth: 300,
    background: "#fff",
    padding: 10,
    borderRadius: 10,
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  }}
>

  <h2 style={{ marginBottom: 5, color: "#198754" }}>
    Employee Absence Entry
  </h2>

  {/* EMP CODE */}
  <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 0, fontWeight: 600 }}>EMP CODE</label>
          <input
  value={absEmpDisplay}
  readOnly
  placeholder="Click to select employee"
  onClick={() => {
  setIsEmpPopupOpen(true);
  setActiveEmpField("absence");
  setIsMultiSelect(true);   // ✅ MULTI
  setSelectedEmps([]);
  setEmpSearchText("");
}}

            style={{
              width: "100%",
              padding: 5,
              border: "1px solid #ccc",
              borderRadius: 8,
              cursor: "pointer",
              backgroundColor: "#f9f9f9",
              transition: "0.2s",
            }}
          />
        </div>

  {/* DATE RANGE */}
  <div style={{ marginBottom:0 }}>
    <label style={{ fontWeight: 600 }}>ABSENCE DATE RANGE</label>
    <div style={{ display: "flex", gap: 5, marginTop: 0 }}>
      <DatePicker
        selected={fromDate}
        onChange={setFromDate}
        dateFormat="yyyy-MM-dd"
        placeholderText="From Date"
        customInput={<input style={inputStyle} />}
      />
      <DatePicker
        selected={toDate}
        onChange={setToDate}
        minDate={fromDate}
        dateFormat="yyyy-MM-dd"
        placeholderText="To Date"
        customInput={<input style={inputStyle} />}
      />
    </div>
  </div>

  {/* START TIME */}
<div style={{ display: "flex", gap: 5, marginBottom: 5, alignItems: "flex-end" }}>
  <div style={{ flex: 1,  }}>
    <label style={{ fontWeight: 600, display: "block", marginBottom: 4 }}>ENTER TIME</label>
    <DatePicker
      selected={startTime}
      onChange={setStartTime}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={1}
      timeCaption="Time"
      dateFormat="HH:mm"
      placeholderText="Select time"
      customInput={<input style={{ ...inputStyle, padding: "6px 8px" }} />}
    />
  </div>

  {/* NO. OF GAPS */}
  <div style={{ width: 120 }}>
    <input
    type="number"
    min="1"
    placeholder="No.of gaps"
      value={absenceCount}
      style={{ width: 110, height: 36, margin: 0, padding: "6px 10px", border: "1px solid #ccc", borderRadius: 6, fontSize: 14 }}
      onChange={(e) => {
        const count = parseInt(e.target.value, 10);
        setAbsenceCount(e.target.value);

        if (!fromDate || !toDate || !startTime || !count) return;

        const result = [];
        let d = new Date(fromDate);

        while (d <= toDate) {
          for (let i = 0; i < count; i++) {
            const slot = new Date(d);
            slot.setHours(startTime.getHours() + i * 2, startTime.getMinutes(), 0, 0);

            const y = slot.getFullYear();
            const m = String(slot.getMonth() + 1).padStart(2, "0");
            const day = String(slot.getDate()).padStart(2, "0");
            const h = String(slot.getHours()).padStart(2, "0");
            const min = String(slot.getMinutes()).padStart(2, "0");

            result.push({ gapDate: `${y}-${m}-${day}T${h}:${min}` });
          }
          d.setDate(d.getDate() + 1);
        }

        setAbsenceGaps(result);
        if (result.length > 0) {

}
      }}
    />
  </div>
</div>
  

  {/* SAVE */}
  <div style={{ display: "flex", gap: 12, marginTop: 10 }}>
 <button
    style={{
  width: "50%",
  height: 46,
  backgroundColor: "#198754",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 600,
  cursor: "pointer",
}}

   onClick={openAbsencePreviewPopup}

  >
    ADD
  </button>
<button
    style={{
  width: "50%",
  height: 46,
  backgroundColor: "#6c757d",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 600,
  cursor: "pointer",
}}
    onClick={handleReset}
  >
    RESET
  </button>
</div>
</div>
        {/* EMP POPUP */}
       {isEmpPopupOpen && (
  <>
    {/* Background overlay */}
    <div
      onClick={() => setIsEmpPopupOpen(false)}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 999,
      }}
    />

    {/* Popup container */}
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 500,
        maxHeight: "80vh",
        background: "#fff",
        padding: 20,
        zIndex: 1000,
        borderRadius: 12,
        overflowY: "auto",
        boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
      }}
    >
      {/* Search input */}
      <input
        placeholder="Search EMP CODE or NAME"
        value={empSearchText}
        onChange={(e) => setEmpSearchText(e.target.value)}
        style={{
          width: "100%",
          marginBottom: 12,
          padding: 8,
          borderRadius: 8,
          border: "1px solid #ccc",
          fontSize: 14,
        }}
      />

      {/* Header grid */}
      <div
  style={{
    display: "grid",
    gridTemplateColumns: isMultiSelect ? "40px 1fr 2fr" : "1fr 2fr",
    padding: "8px 10px",
    borderBottom: "2px solid #198754",
    fontSize: 14,
    textAlign: "center",
    fontWeight: "bold",
  }}
>
  {isMultiSelect && <div>Select</div>}
  <div>EMP CODE</div>
  <div>EMP NAME</div>
</div>


      {/* Employee list */}
      <div style={{ maxHeight: 300, overflowY: "auto" }}>
      {filteredEmployees.map((emp) => {
  const checked = selectedEmpCodeSet.has(emp.EMP_CODE);

  return (
    
    <div
      key={emp.EMP_CODE}
      style={{
        display: "grid",
        gridTemplateColumns: isMultiSelect ? "50px 1fr 2fr" : "1fr 2fr",
        padding: "6px 10px",
        borderBottom: "1px solid #e0e0e0",
        alignItems: "center",
        fontSize: 14,
      }}
       onClick={() => {
  if (!isMultiSelect) {
    if (activeEmpField === "absence") {
      setAbsEmpCode(emp.EMP_CODE);
      setAbsEmpDisplay(`${emp.EMP_CODE} — ${emp.EMP_NAME}`);
    } else {
      setEmpCode(emp.EMP_CODE);
      setEmpDisplay(`${emp.EMP_CODE} — ${emp.EMP_NAME}`);
    }
    setIsEmpPopupOpen(false);
  }
}}
    >
      {isMultiSelect && (
        <div style={{ textAlign: "center" }}>
          <input
            type="checkbox"
            checked={checked}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              e.stopPropagation();
              setSelectedEmps(prev =>
                checked
                  ? prev.filter(x => x.EMP_CODE !== emp.EMP_CODE)
                  : [...prev, emp]
              );
            }}
          />
        </div>
      )}

     {/* EMP_CODE centered */}
        <div style={{ textAlign: "center" }}>{emp.EMP_CODE}</div>

        {/* EMP_NAME left-aligned */}
        <div style={{ paddingLeft: 8, textAlign: "left" }}>{emp.EMP_NAME}</div>
      </div>
  );
})}

{isMultiSelect && selectedEmps.length > 0 && (
  <div
    style={{
      marginTop: 10,
      padding: 10,
      border: "1px solid #dee2e6",
      borderRadius: 8,
      background: "#f8fdfb",
      fontSize: 13,
      maxHeight: 120,
      overflowY: "auto",
    }}
  >
    <strong>Selected Employees ({selectedEmps.length})</strong>
    {selectedEmps.map(e => (
      <div key={e.EMP_CODE}>
        {e.EMP_CODE} — {e.EMP_NAME}
      </div>
    ))}
  </div>
)}
      </div>
 {/* APPLY + RESET BUTTONS */}
{isMultiSelect && (
  <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
    <button
 onClick={() => {
  const codes = selectedEmps.map((e) => e.EMP_CODE);

if (activeEmpField === "gap") {
  setGapEmpCodes(codes);
  setGapSelectedEmps(selectedEmps);

  setEmpDisplay(
    selectedEmps.map((e) => `${e.EMP_CODE} — ${e.EMP_NAME}`).join(", ")
  );

  setEmpCode(codes.length === 1 ? codes[0] : "");

  // ✅ AUTO DISABLE LOCATION
  if (codes.length > 1) {
    setLocation("");
  }
}

  if (activeEmpField === "absence") {
    setAbsenceEmpCodes(codes);
    setAbsenceSelectedEmps(selectedEmps);

    setAbsEmpDisplay(
      selectedEmps.map((e) => `${e.EMP_CODE} — ${e.EMP_NAME}`).join(", ")
    );

    setAbsEmpCode(codes.length === 1 ? codes[0] : "");
  }

  setIsEmpPopupOpen(false);
}}

  style={{
    flex: 1,
    padding: 10,
    backgroundColor: "#198754",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontWeight: "bold",
    cursor: "pointer",
  }}
>
  Apply
</button>

    {/* RESET */}
<button
 onClick={() => {
  setSelectedEmps([]);

  if (activeEmpField === "gap") {
    setGapEmpCodes([]);
    setGapSelectedEmps([]);
    setEmpDisplay("");
    setEmpCode("");
  }

  if (activeEmpField === "absence") {
    setAbsenceEmpCodes([]);
    setAbsenceSelectedEmps([]);
    setAbsEmpDisplay("");
    setAbsEmpCode("");
  }

  setEmpSearchText("");
}}

      style={{
        flex: 1,
        padding: 10,
        backgroundColor: "#6c757d",
        color: "#fff",
        border: "none",
        borderRadius: 8,
        fontWeight: "bold",
        cursor: "pointer",
      }}
    >
      Reset
    </button>

<button
  onClick={() => setIsEmpPopupOpen(false)}
  style={{
    position: "absolute",
    top: -10,             // slightly above popup
    right: -5,           // slightly outside popup
    width: 32,            // horizontal size
    height: 30,           // vertical size (equal → perfect circle)
    borderRadius: "50%",  // makes it a circle
    backgroundColor: "#dc3545", // red moon
    color: "#fff",        // white cross
    border: "none",
    fontSize: 20,
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  }}
>
  ×
</button>



  </div>
)}



    </div>
  </>
)}
</div>

{isLocationPopupOpen && (
  <>
    {/* Background overlay */}
    <div
      onClick={() => setIsLocationPopupOpen(false)}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 999,
      }}
    />

    {/* Popup container */}
    <div
  onClick={(e) => e.stopPropagation()}
  style={{
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    maxHeight: "80vh",
    background: "#fff",
    padding: 20,
    zIndex: 1000,
    borderRadius: 12,
    overflowY: "auto",
    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
  }}
>


  {/* popup content starts here */}

      {/* Search input */}
      <input
        placeholder="Search Vehicle ID or Plate"
        value={locationSearch}
        onChange={(e) => setLocationSearch(e.target.value.toLowerCase())}
        style={{
          width: "100%",
          marginBottom: 12,
          padding: 8,
          borderRadius: 8,
          border: "1px solid #ccc",
          fontSize: 14,
        }}
      />

      {/* Header grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 2fr",
          padding: "8px 10px",
          borderBottom: "2px solid #198754",
          marginBottom: 6,
          fontSize: 14,
          textAlign: "center",
        }}
      >
        <div style={{ fontWeight: "bold" }}>ID</div>
        <div style={{ fontWeight: "bold" }}>VEHICLE PLATE</div>
      </div>

      {/* Location list grid */}
      <div style={{ maxHeight: 300, overflowY: "auto" }}>
        {filteredLocationList.map((v) => (
            <div
              key={v.ID}
              onClick={() => {
                setLocation(v.GP_PLATE);

                setIsLocationPopupOpen(false);
              }}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 2fr",
                padding: "8px 10px",
                cursor: "pointer",
                borderBottom: "1px solid #e0e0e0",
                borderRight: "1px solid #e0e0e0",
                borderLeft: "1px solid #e0e0e0",
                alignItems: "center",
                fontSize: 14,
                textAlign: "center",
                transition: "0.2s",
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#f1f3f5")}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
            >
              <div>{v.ID}</div>
              <div>{v.GP_PLATE}</div>
            </div>
          ))}
      </div>

      {/* CLOSE BUTTON */}
      <button
        onClick={() => setIsLocationPopupOpen(false)}
        style={{
          marginTop: 12,
          width: "100%",
          padding: "10px 0",
          backgroundColor: "#198754",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          cursor: "pointer",
          transition: "0.2s",
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#157347")}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#198754")}
      >
        Close
      </button>
    </div>
  </>
)}

{isPreviewPopupOpen && (
  <>
    {/* Overlay */}
    <div
      onClick={() => setIsPreviewPopupOpen(false)}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 999,
      }}
    />

    {/* Popup */}
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 650,
        maxHeight: "80vh",
        background: "#fff",
        padding: 20,
        zIndex: 1000,
        borderRadius: 12,
        overflowY: "auto",
        boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3 style={{ margin: 0, color: "#198754" }}>Preview Gap Entries</h3>

        <button
          onClick={() => setIsPreviewPopupOpen(false)}
          style={{
            border: "none",
            background: "transparent",
            fontSize: 22,
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          ×
        </button>
      </div>
      {/* Summary */}
      <div style={{ marginTop: 20, marginBottom: 12, fontSize: 14 }}>
        <p><b>Total Employees:</b> {selectedEmps.length}</p>
        <p><b>Total Gap Entries:</b> {previewData.length}</p>
      </div>

    <div style={{ maxHeight: 250, overflowY: "auto" }}>
  <table
    style={{
      width: "100%",
      borderCollapse: "collapse",
      fontSize: 13,
      tableLayout: "fixed",
    }}
  >
 <thead>
      <tr style={{ background: "#198754", color: "#fff" }}>
        <th style={{ padding: 10, border: "1px solid #ddd", textAlign: "center", verticalAlign: "middle" }}>
          EMP CODE
        </th>

        <th style={{ padding: 10, border: "1px solid #ddd", textAlign: "center", verticalAlign: "middle" }}>
          EMP NAME
        </th>

<th style={{ padding: 10, border: "1px solid #ddd", textAlign: "center", verticalAlign: "middle" }}>
          LOCATION
        </th>

        <th style={{ padding: 10, border: "1px solid #ddd", textAlign: "center", verticalAlign: "middle" }}>
          GAP DATE & TIME
        </th>
      </tr>
    </thead>


    <tbody>
  {previewData.map((row, index) => (
    <tr key={index}>
      <td style={{ padding: 10, border: "1px solid #ddd", textAlign: "center" }}>
        {row.empCode}
      </td>

      <td style={{ padding: 10, border: "1px solid #ddd", textAlign: "center" }}>
        {row.empName}
      </td>

      <td style={{ padding: 10, border: "1px solid #ddd", textAlign: "center" }}>
        {row.location}
      </td>

      <td style={{ padding: 10, border: "1px solid #ddd", textAlign: "center" }}>
        {row.gapDate.replace("T", " ")}
      </td>
    </tr>
  ))}
</tbody>

  </table>
</div>


      {/* Buttons */}
      <div style={{ display: "flex", gap: 12, marginTop: 15 }}>
        <button
          onClick={() => setIsPreviewPopupOpen(false)}
          style={{
            flex: 1,
            backgroundColor: "#6c757d",
            color: "#fff",
            padding: 12,
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Cancel
        </button>

        <button
          onClick={async () => {
            setIsPreviewPopupOpen(false);
            await handleSave();
          }}
          style={{
            flex: 1,
            backgroundColor: "#198754",
            color: "#fff",
            padding: 12,
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Confirm & Save
        </button>
      </div>
    </div>
  </>
)}

{isAbsencePreviewOpen && (
  <>
    {/* Overlay */}
    <div
      onClick={() => setIsAbsencePreviewOpen(false)}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 999,
      }}
    />

    {/* Popup */}
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 650,
        maxHeight: "80vh",
        background: "#fff",
        padding: 20,
        zIndex: 1000,
        borderRadius: 12,
        overflowY: "auto",
        boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3 style={{ margin: 0, color: "#198754" }}>
          Preview Absence Entries
        </h3>

        <button
          onClick={() => setIsAbsencePreviewOpen(false)}
          style={{
            border: "none",
            background: "transparent",
            fontSize: 22,
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          ×
        </button>
      </div>

      {/* Summary */}
      <div style={{ marginTop: 20, marginBottom: 12, fontSize: 14 }}>
  <p style={{ margin: "6px 0" }}>
    <b>Total Employees:</b> {absenceEmpCodes.length}
  </p>

  <p><b>Total Gap Entries:</b> {absencePreviewData.length}
  </p>
</div>


      {/* Table */}
     <div style={{ maxHeight: 250, overflowY: "auto" }}>
  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
    <thead>
      <tr style={{ background: "#198754", color: "#fff" }}>
        <th style={{ padding: 10, border: "1px solid #ddd", textAlign: "center", verticalAlign: "middle" }}>
          EMP CODE
        </th>

        <th style={{ padding: 10, border: "1px solid #ddd", textAlign: "center", verticalAlign: "middle" }}>
          EMP NAME
        </th>

        <th style={{ padding: 10, border: "1px solid #ddd", textAlign: "center", verticalAlign: "middle" }}>
          GAP DATE & TIME
        </th>
        <th
  style={{
    padding: 10,
    border: "1px solid #ddd",
    textAlign: "center",
    verticalAlign: "middle",
  }}
>
  ACTION
</th>
      </tr>
    </thead>


    <tbody>
  {absencePreviewData.map((row, index) => (
    <tr key={index}>
      <td style={{ padding: 10, border: "1px solid #ddd", textAlign: "center" }}>
        {row.empCode}
      </td>

      <td style={{ padding: 10, border: "1px solid #ddd", textAlign: "center" }}>
        {row.empName}
      </td>

      <td style={{ padding: 10, border: "1px solid #ddd", textAlign: "center" }}>
        {row.gapDate.replace("T", " ")}
      </td>

      {/* ✅ DELETE BUTTON COLUMN */}
      <td style={{ padding: 10, border: "1px solid #ddd", textAlign: "center" }}>
        <button
          onClick={() => {
            const updated = absencePreviewData.filter(
              (_, i) => i !== index
            );
            setAbsencePreviewData(updated);
          }}
          style={{
            backgroundColor: "#dc3545",
            color: "#fff",
            border: "none",
            padding: "6px 10px",
            borderRadius: 6,
            cursor: "pointer",
            fontSize: 12,
          }}
        >
          🗑️ Delete
        </button>
      </td>
    </tr>
  ))}
</tbody>
  </table>
</div>


      {/* Buttons */}
      <div style={{ display: "flex", gap: 12, marginTop: 15 }}>
        <button
          onClick={() => setIsAbsencePreviewOpen(false)}
          style={{
            flex: 1,
            backgroundColor: "#6c757d",
            color: "#fff",
            padding: 12,
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Cancel
        </button>

        <button
          onClick={async () => {
  setIsAbsencePreviewOpen(false);
  await handleSaveAbsence();
}}

          style={{
            flex: 1,
            backgroundColor: "#198754",
            color: "#fff",
            padding: 12,
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Confirm & Save
        </button>
      </div>
    </div>
  </>
)}


 {/* RIGHT SIDE TABLE */}
    <div className="emp-gap-right"
    style={{
    flex: 1.4,
    minWidth: 600,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  }}
    >

      {/* ======= YOUR TABLE CARD CODE (PASTE HERE) ======= */}
      <h2 style={{ marginBottom: 15, color: "#198754" }}>
        Employee Gap Entries
      </h2>

      {/* FILTER BAR */}
      <div
        className="emp-filter-bar"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 15,
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        {/* LEFT : SEARCH */}
        <div style={{ flex: 1, maxWidth: 320 }}>
          <input
            type="text"
            placeholder="🔍 Search Emp Code / Name"
            value={tableSearch}
            onChange={(e) => setTableSearch(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 12px",
              border: "1px solid #ccc",
              borderRadius: 8,
              fontSize: 13,
            }}
          />
        </div>

        {/* RIGHT : FROM / TO */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <span style={{ fontSize: 13, fontWeight: 600 }}>From</span>
          <input
            type="date"
            value={filterFromDate}
            onChange={(e) => setFilterFromDate(e.target.value)}
            style={{
              padding: "6px 8px",
              border: "1px solid #adb5bd",
              borderRadius: 6,
              height: 34,
            }}
          />

          <span style={{ fontSize: 13, fontWeight: 600 }}>To</span>
          <input
            type="date"
            value={filterToDate}
            onChange={(e) => setFilterToDate(e.target.value)}
            style={{
              padding: "6px 8px",
              border: "1px solid #adb5bd",
              borderRadius: 6,
              height: 34,
            }}
          />
        </div>
      </div>

      {/* TABLE */}
      <div
        className="emp-gap-table-wrapper"
       style={{
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  paddingBottom: 10,
  border: "1px solid #dee2e6",
  borderRadius: 8,
}}

      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: 13,
          }}
        >
          <thead>
            <tr>
              {["Emp Code", "Emp Name", "Location", "GAP Date", "Actions"].map(
                (title) => (
                  <th
                    key={title}
                    style={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#198754",
                      color: "#fff",
                      padding: 12,
                      border: "1px solid #ccc",
                      zIndex: 10,
                      textAlign: "center",
                    }}
                  >
                    {title}
                  </th>
                )
              )}
            </tr>
          </thead>

  <tbody>
    {filteredEntries.length === 0 ? (
      <tr>
        <td colSpan="5" style={{ padding: 12, textAlign: "center" }}>No data</td>
      </tr>
    ) : (
      filteredEntries.map((row, index) => (
        <tr
          key={`${row.EMP_CODE}-${row.GAP_DATE}-${index}`}
          style={{
            backgroundColor: index % 2 === 0 ? "#f8fdfb" : "#ffffff",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e9f7ef")}
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor =
              index % 2 === 0 ? "#f8fdfb" : "#ffffff")
          }
        >
          <td style={{ padding: 12, border: "1px solid #ccc", textAlign: "center" }}>{row.EMP_CODE}</td>
          <td style={{ padding: 12, border: "1px solid #ccc", textAlign: "center" }}>{row.EMP_NAME || empMap[row.EMP_CODE] || "-"}</td>
          <td style={{ padding: 12, border: "1px solid #ccc", textAlign: "center" }}>{row.LOCATION || "-"}</td>
          <td style={{ padding: 12, border: "1px solid #ccc", textAlign: "center" }}>
            {row.GAP_DATE.replace("T", " ").slice(0, 16)}
          </td>
          <td style={{ padding: 12, borderBottom: "1px solid #ccc", textAlign: "center" }}>
            <button
              onClick={() => handleEdit(row)}
              style={{
                marginRight: 6,
                backgroundColor: "#198754",
                color: "#fff",
                padding: "5px 12px",
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
                transition: "0.2s",
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#157347")}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#198754")}
            >
              Edit
            </button>
            <button
              onClick={() => handleDelete(row)}
              style={{
                backgroundColor: "#dc3545",
                color: "#fff",
                padding: "5px 12px",
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
                transition: "0.2s",
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#c82333")}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#dc3545")}
            >
              Delete
            </button>
          </td>
        </tr>
      ))
    )}
  </tbody>
</table>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 10,
            marginBottom: 10,
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: 13, color: "#495057" }}>
            Showing {filteredEntries.length} of {entriesTotal} entries
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button
              onClick={() => fetchEntries({ page: Math.max(1, entriesPage - 1) })}
              disabled={entriesPage <= 1}
              style={{
                padding: "6px 12px",
                border: "1px solid #ced4da",
                borderRadius: 6,
                background: entriesPage <= 1 ? "#e9ecef" : "#fff",
                cursor: entriesPage <= 1 ? "not-allowed" : "pointer",
              }}
            >
              Prev
            </button>
            <span style={{ fontSize: 13 }}>
              Page {entriesPage} / {Math.max(1, Math.ceil(entriesTotal / ENTRIES_PAGE_SIZE))}
            </span>
            <button
              onClick={() => fetchEntries({ page: entriesPage + 1 })}
              disabled={entriesPage >= Math.max(1, Math.ceil(entriesTotal / ENTRIES_PAGE_SIZE))}
              style={{
                padding: "6px 12px",
                border: "1px solid #ced4da",
                borderRadius: 6,
                background:
                  entriesPage >= Math.max(1, Math.ceil(entriesTotal / ENTRIES_PAGE_SIZE))
                    ? "#e9ecef"
                    : "#fff",
                cursor:
                  entriesPage >= Math.max(1, Math.ceil(entriesTotal / ENTRIES_PAGE_SIZE))
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              Next
            </button>
          </div>
        </div>
         <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
  <button
    onClick={handleLogout}
    style={{
      background: "transparent",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
    }}
    title="Logout"
  >
    🚪➡️
  </button>
</div>
        </div>
      </div>

  );
}

export default EmpGapForm;
